<template>
  <div>
    <qd-notification :closable="false" ref="element"
                    class="has-background-background is-paddingless">
      <div class="columns is-multiline" v-if="totaux">
        <div class="column is-narrow">
          <div class="card-content has-background-white">
            {{ $t('dcf.suiviMensuel.totalMntBrouillonHorsTlpe' )}} :
            <span class="right"
            v-if="totaux.totalMntBrouillonHorsTlpe || totaux.totalMntBrouillonHorsTlpe === 0">
              {{ totaux.totalMntBrouillonHorsTlpe | formatDevise }}
            </span>
            <span v-else class="has-text-warning is-inline-block">
              <b-tooltip class="width-100percent"
                  :label="$t('dcf.suiviMensuel.nonCalculeTooltip')"
                  multiline
                  type="is-warning"
                  position="is-bottom"
                    v-if="!exerciceOk">
              {{ $t('dcf.suiviMensuel.nonCalcule')}}
              </b-tooltip>
            </span>
          </div>
        </div>
        <div class="column is-narrow">
          <div class="card-content has-background-white">
            {{ $t('dcf.suiviMensuel.totalMntBrouillonTlpe' )}} :
            <span class="right"
            v-if="totaux.totalMntBrouillonTlpe || totaux.totalMntBrouillonTlpe === 0">
              {{ totaux.totalMntBrouillonTlpe | formatDevise }}
            </span>
            <span v-else class="has-text-warning is-inline-block">
              <b-tooltip class="width-100percent"
                  :label="$t('dcf.suiviMensuel.nonCalculeTooltip')"
                  multiline
                  type="is-warning"
                  position="is-bottom"
                    v-if="!exerciceOk">
              {{ $t('dcf.suiviMensuel.nonCalcule')}}
              </b-tooltip>
            </span>
          </div>
        </div>
        <div class="column is-narrow">
          <div class="card-content has-background-white">
            {{ $t('dcf.suiviMensuel.totalMntFactureHorsTlpe' )}} :
            <span class="right"
            v-if="totaux.totalMntFactureHorsTlpe || totaux.totalMntFactureHorsTlpe === 0">
              {{ totaux.totalMntFactureHorsTlpe | formatDevise }}
            </span>
            <span v-else class="has-text-warning is-inline-block">
              <b-tooltip class="width-100percent"
                  :label="$t('dcf.suiviMensuel.nonCalculeTooltip')"
                  multiline
                  type="is-warning"
                  position="is-bottom"
                    v-if="!exerciceOk">
              {{ $t('dcf.suiviMensuel.nonCalcule')}}
              </b-tooltip>
            </span>
          </div>
        </div>
        <div class="column is-narrow">
          <div class="card-content has-background-white">
            {{ $t('dcf.suiviMensuel.totalMntFactureTlpe' )}} :
            <span class="right"
            v-if="totaux.totalMntFactureTlpe || totaux.totalMntFactureTlpe === 0">
              {{ totaux.totalMntFactureTlpe | formatDevise }}
            </span>
            <span v-else class="has-text-warning is-inline-block">
              <b-tooltip class="width-100percent"
                  :label="$t('dcf.suiviMensuel.nonCalculeTooltip')"
                  multiline
                  type="is-warning"
                  position="is-bottom"
                    v-if="!exerciceOk">
              {{ $t('dcf.suiviMensuel.nonCalcule')}}
              </b-tooltip>
            </span>
          </div>
        </div>
        <div class="column is-narrow">
          <div class="card-content has-background-white">
            {{ $t('dcf.suiviMensuel.totalMntAFacture' )}} :
            <span class="right">
              {{ totaux.totalMntAFacture | formatDevise }}
            </span>
          </div>
        </div>
      </div>
    </qd-notification>
  </div>
</template>

<script>

import PGetTotalMntFacturerBrouillonAFacturer from '@/api/devisCommandeFacture';
import formatDateIso from '@/services/general/formatIsoDate';
import messageErreur from '@/services/general/messageErreur';
import { DATE_MAX, DATE_MIN } from '@/configuration/general/dateConf';

export default {
  props: {
    agencesIds: {
      type: Array,
      required: true,
    },
    societeId: {
      type: String,
      required: true,
    },
    periode: {
      type: Object,
      required: true,
    },
    parutionsIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      totaux: null,
      paramsRecherche: null,
    };
  },
  methods: {
    async reload() {
      const loadingComponent = this.$buefy.loading.open({ container: this.$refs.element.$el });
      try {
        this.paramsRecherche = {
          agencesIds: this.agencesIds,
          societeId: this.societeId,
          dateDebut: this.periode.dateDebut ? formatDateIso(this.periode.dateDebut)
            : formatDateIso(DATE_MIN),
          dateFin: this.periode.dateFin ? formatDateIso(this.periode.dateFin)
            : formatDateIso(DATE_MAX),
          parutionsIds: this.parutionsIds,
        };
        this.totaux = (await PGetTotalMntFacturerBrouillonAFacturer(this.paramsRecherche))
          .data.result;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
};

</script>
